import axios from 'axios';
import { getToken } from './auth';
import { invalidateProducts } from '../utils/productEventsHub';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';
const priceListPromotionUrl = (branchId, suffix = '') => (
  `${API_URL}/branch/${branchId}/product/price-list/promotions${suffix}`
);

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getPromotions = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/promotions`, { ...withAuth(), params })).data;

export const getPromotionById = async (branchId, id) =>
  (await axios.get(`${API_URL}/branch/${branchId}/promotions/${id}`, withAuth())).data;

export const createPromotion = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/promotions`, data, withAuth())).data;

export const updatePromotion = async (branchId, id, data) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/promotions/${id}`, data, withAuth())).data;

export const deletePromotion = async (branchId, id) =>
  (await axios.delete(`${API_URL}/branch/${branchId}/promotions/${id}`, withAuth())).data;

export const createPriceListPromotions = async (branchId, payload) => {
  const response = (await axios.post(
    priceListPromotionUrl(branchId, '/bulk'),
    payload,
    withAuth()
  )).data;
  invalidateProducts(branchId, {
    action: 'price-list-promotions-created',
    priceIds: payload?.varietyPriceIds,
  });
  return response;
};

export const replacePriceListPromotion = async (branchId, promotionId, payload) => {
  const response = (await axios.post(
    priceListPromotionUrl(branchId, `/${promotionId}/replace`),
    payload,
    withAuth()
  )).data;
  invalidateProducts(branchId, {
    action: 'price-list-promotion-replaced',
    priceIds: response?.promotion?.varietyPriceId
      ? [response.promotion.varietyPriceId]
      : payload?.varietyPriceIds,
  });
  return response;
};

export const endPriceListPromotion = async (branchId, promotionId) => {
  const response = (await axios.delete(
    priceListPromotionUrl(branchId, `/${promotionId}`),
    withAuth()
  )).data;
  invalidateProducts(branchId, {
    action: 'price-list-promotion-ended',
    priceIds: response?.promotion?.varietyPriceId
      ? [response.promotion.varietyPriceId]
      : undefined,
  });
  return response;
};

export const getPriceListPromotionHistory = async (branchId, params = {}) => (
  await axios.get(priceListPromotionUrl(branchId, '/history'), {
    ...withAuth(),
    params,
  })
).data;
